export default {
	units: {
		position: 'Position',
		modeOfUse: 'Type of administration',
		area: 'Area in m²',
		unit: 'Unit',
		commercial: 'Commercial',
		partialOwnership: 'Partial ownership',
		garage: 'Garage',
		tax: 'VAT opted',
	},
}
